// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFoundPage_notFoundPage__Dz5aQ"};